import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback } from 'react';
import { Box, Typography } from '@mui/material';
import { CustomIcon } from 'console/shared/components/icon/custom';
import { array_id_main_icons, } from 'console/shared/components/fields/icon/icons';
import { IconItemWithPopup } from 'console/shared/components/fields/icon/utils';
import { LightTooltip } from 'shared/components/icon/icon.user_icons_panel/style';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { ColorSvgIcon } from 'shared/components/icon/style-for-custom';
export const IconPanelSelectDevice = memo(function IconPanel(props) {
    const { onChangeIcon, filterArrayNotSimilar, customTab } = props;
    const is_demo = useAppSelector((state) => state.account.is_demo);
    const onChange = useCallback((Icon, need_draw) => {
        if (!need_draw || customTab) {
            onChangeIcon && onChangeIcon(Icon.id);
        }
        return null;
    }, []);
    return (_jsx(Box, { sx: {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-around',
        }, children: filterArrayNotSimilar?.map((Icon) => {
            const need_draw = array_id_main_icons.find((icon_id) => icon_id === Icon.id);
            return (_jsx(Box, { padding: "5px", onClick: () => onChange(Icon, need_draw), children: _jsx(LightTooltip, { title: _jsx(Box, { display: 'flex', flexDirection: 'column', children: _jsx(Typography, { alignItems: 'center', children: Icon.title }) }), children: _jsx(ColorSvgIcon, { children: need_draw ? (_jsx(IconItemWithPopup, { option: Icon, onClickPopupItem: onChangeIcon, ...props, demo: is_demo, children: _jsx(CustomIcon, { Icon: Icon.render, fontSize: "3em" }) })) : (_jsx(CustomIcon, { Icon: Icon.render, fontSize: "3em" })) }) }) }, Icon.id));
        }) }));
});
